define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def/Action",
	"csi/def/ViewRef",
	"csi/heading/Ref",
	"csi/reflection",
	"csi/xml",
	"csi/xml/Query"
], function(declare,lang,Action,ViewRef,Ref,reflection,xml,Query) {

	return declare(Ref, {
		_getStoreAction: function(/*Context*/ctx, /*Heading*/h) {
			// summary: return action to query for all available colored materials
			var	node = ctx.getNode();
			var	material = ctx.cache.getNode(node.Actual || node.MPCMaterial, true);
			if (material) {
				return lang.mixin(new Action(), {
					m_fixedQuery: new Query()
						.Attr("Active", xml.OP_EQUALS, true)
						.Access(xml.RIGHT_READ, reflection.PATH_PARENT),
					m_viewRef: lang.mixin(new ViewRef(), {
						m_id: "ProductColors",
						m_url: material.$URL
					})
				});
			}

			return lang.mixin(new Action(), {
				m_fixedQuery: new Query()
					.Attr("Active", xml.OP_EQUALS, true)
					.Attr("UsableForStyleBOM", xml.OP_EQUALS, true, reflection.PATH_PARENT),
				m_viewRef: lang.mixin(new ViewRef(), {
					m_id: "ColoredMaterials",
					m_url: "centric://APPAREL/Views"
				})
			});
		}
	});
});